import { ParsedUrlQuery } from 'querystring'

import type { NavMenuContentType } from '@hhgtech/hhg-components/components/navigationV2/index'

import { HEALTH_TOOL_NAME } from 'interfaces/constants/healthTools'
import {
  AdditionalQuestionFieldType,
  CommonHealthtoolInfo,
  FooterInfo,
  LeadGenInfo,
  WeekOfPregnancyApi,
} from 'interfaces/types'
import { DueDateInfoApi } from 'interfaces/types/DueDate'

export enum ResultStatus {
  idle = 'idle',
  loading = 'loading',
  error = 'error',
}

export type OtherInfo = {
  first_day?: string | null
  cycle_length_days?: number | null
  conception_date?: string | null
  ivf_transfer_date?: string | null
  insemination_date?: string | null
  crl_value?: number | null
  msd_value?: number | null
  measurement_date?: string | null // ultrasound_date
  days_transfer?: number | null
  method?: number | null
}

export type Week = {
  date: string
  dateType2: string
  dateType3: string
  title: string
  content: string
}

export type Props = {
  isMobileSsr: boolean
  pageType?: HEALTH_TOOL_NAME
  dueDatePageInfo: DueDateInfoApi & LeadGenInfo & CommonHealthtoolInfo
  dueDateAllWeeks: Array<WeekOfPregnancyApi>
  dueDateFaqs: {
    [key: string]: [
      {
        title: string
        content: string
      },
    ]
  }
  query: ParsedUrlQuery
  userInfo?: any
  footerInfo?: FooterInfo
  dataNavMenuContent?: NavMenuContentType
}
export type DueDateInfoType = {
  startDate: Date | null
  dueDate: Date | null
  otherInfo: OtherInfo
  isMyself?: boolean
  isFirstPregnant?: boolean
  birthday?: string
  additionalQuestions?: Array<AdditionalQuestionFieldType>
}
